import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, Data } from '@angular/router';

import { HisAuthService } from '../service/his-auth.service';
import { HisBaseGlobalsService } from '../../core/service/base/his-base-globals.service';
import { HisNavigationService } from '../../core/service/base/his-navigation.service';

@Injectable({providedIn: 'root'})
export class HisAuthGuard  {
    private hisAuthService = inject(HisAuthService);
    private hisBaseGlobalsService = inject(HisBaseGlobalsService);
    private hisNavigationService = inject(HisNavigationService);
    private router = inject(Router);


    canActivate( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ): boolean {
        let enabled = this.isEnabled( route );
        if ( !enabled ) {
            this.router.navigate( ['/hisng/access-disabled'], {
                skipLocationChange: true
            } );
        }

        let granted = this.isGranted( route );
        if ( !granted ) {
            this.hisNavigationService.navigateToAccessDenied();
        }

        return enabled && granted;
    }

    private isEnabled( route: ActivatedRouteSnapshot ): boolean {
        if ( !route.data ) {
            return true;
        }

        let data = route.data as (Data & {modules: string[]; anonmodules: string[]});

        if ( !data.modules ) {
            return true;
        }

        if ( this.hisAuthService.isAnonymous && data.anonmodules) {
            return this.hisBaseGlobalsService.isAnyModuleActive( ...data.anonmodules );
        }
        return this.hisBaseGlobalsService.isAnyModuleActive( ...data.modules );
    }

    private isGranted( route: ActivatedRouteSnapshot ): boolean {
        if ( !route.data ) {
            console.error( 'HisAuthGuard without configuration data in route definition.' );
            return false;
        }

        let data = route.data as (Data & {hasAll: string[]; hasAny: string[]});

        // check hasAll
        if ( data.hasAll ) {
            let granted = this.hisAuthService.hasAll( ...data.hasAll );
            if ( !granted ) {
                return false;
            }
        }

        // check hasAny
        if ( data.hasAny ) {
            return this.hisAuthService.hasAny( ...data.hasAny );
        }

        // check hasAll was true, and hasAny was not defined
        return true;
    }
}
